<script>
import Anxunheader from "@/views/Anxun/component/Anxunheader.vue";
import kefu from "@/views/kefu.vue";
import headtip from "@/views/headTip.vue";
import kefuMobile from "@/views/kefuMobile.vue";
import bottomTip from "@/views/bottomTip.vue";
import { shareUrl } from "@/utils/vxshare";
import consultTip from "@/components/consultTip.vue";
// Constants for page content
const PAGE_CONTENT = {
  headertitle1: " Software development and talent<br> outsourcing services \n\n\n",
  headertitle1Mobile: " Software development and talent outsourcing services \n\n\n",
  headertitle2: " Professional software development team support to meet the short-term or long-term needs of customers in project development and technical operation and maintenance\n\n\n",
  headerimg: require("@/assets/Inspection1.png"),
  introduce: "Based on safety regulations and industry standards, we build a knowledge base of potential hazards and risks, and combine it with multi-terminal technologies to achieve risk management and control, hazard detection, rectification, acceptance, and management. Through intelligent analysis, prediction and early warning, and safety performance management, we improve the efficiency of safety management and the ability to control risks.\n"
};

// Desktop data
const SECTION_DATA = [
  {
    title: " Business challenges and pain points",
    img: "/subcontract1.png"
  },
  {
    title: " Service content",
    img: "/subcontract2.png"
  },
  {
    title: " Customer income",
    img: "/subcontract3.png"
  }
];

// Mobile data
const MOBILE_SECTION_DATA = [
  {
    title: " Business challenges and pain points",
    img: "/subcontract11.png"
  },
  {
    title: " Service content",
    img: "/subcontract12.png"
  },
  {
    title: " Customer income",
    img: "/subcontract13.png"
  }
];

export default {
  name: 'SoftwareSubcontract',
  components: {
    bottomTip,
    kefuMobile,
    Anxunheader,
    kefu,
    headtip,
    consultTip,
  },
  data() {
    return {
      dialogVisible: false,
      title: '',
      model: false,
      texttotal: PAGE_CONTENT,
      data: SECTION_DATA,
      data2: MOBILE_SECTION_DATA,
      // pc端新增数据
      challenges: [
        {
          icon: require('@/assets/software/exploit/u2.webp'),  // 人才招聘周期长图标
          title: ' Long talent recruitment cycle',
          description: ' The cycle of enterprises recruiting technical talents is too long, resulting in the delay in the start of the project.'
        },
        {
          icon: require('@/assets/software/exploit/u3.webp'),  // 团队能力图标
          title: ' Insufficient team ability ',
          description: 'The technical ability of the existing team cannot meet the development needs of specific fields and needs expert support. '
        },
        {
          icon: require('@/assets/software/exploit/u4.webp'),  // 长期图标
          title: 'Long-term cost pressure',
          description: 'The cost of maintaining a large-scale R&D team is high, and a more flexible talent strategy is urgently needed. '
        }
      ],
      serviceList: [
        {
          title: ' Flexible cooperation model',
          description: 'Support on-site development (dispatching engineers to the customers site to participate in the project), remote collaboration (development team delivers tasks online), and a variety of cooperation models such as project-based, hourly or long-term employment to ensure that enterprises can obtain the required technical support at the best cost.',
          icon: require('@/assets/software/exploit/u28.webp')
        },
        {
          title: ' Quickly match technical talents',
          description: ' Based on the business needs of the enterprise and the technical requirements of the project, quickly recommend developers with relevant experience, covering front-end, back-end, mobile, database, operation and maintenance and other fields to ensure that personnel skills are accurately matched with project needs. At the same time, support short-term  /  Long-term employment to meet the employment needs of enterprises at different stages. ',
          icon: require('@/assets/software/exploit/u35.webp')
        },

        {
          title: 'End-to-end PM support',
          description: 'Mature project management system, combined with agile development (  Agile  ) or waterfall development (  Waterfall  ), ensure that the development progress can be controlled, the division of tasks is clear, and the communication cost is reduced.Provide code audit, quality assurance and regular reporting mechanisms to ensure that the deliverables meet customer expectations and complete the project goals on time. ',
          icon: require('@/assets/software/exploit/u37.webp')
        }
      ],
      benefitList: [
        {
          icon: require('@/assets/software/exploit/u26.webp'),
          title: ' Quickly set up a development team to reduce recruitment costs ',
          desc: 'Relying on the abundant talent reserve, enterprises do not need to invest a lot of time in recruitment, and can quickly match suitable developers, fill technical vacancies, and reduce recruitment costs. '
        },
        {
          icon: require('@/assets/software/exploit/u27.webp'),
          title: 'Ensure timely project delivery according to schedule ',
          desc: ' Provide professional project management, combined with agile development, to ensure reasonable task allocation and controllable progress. Flexible allocation of technical personnel to quickly respond to changes in demand and avoid affecting the progress of the project due to personnel shortage. '
        },
        {
          icon: require('@/assets/software/exploit/u29.webp'),
          title: ' Flexible expansion of the technical team ',
          desc: ' Enterprises can flexibly adjust the development team according to business needs to avoid the redundancy cost of fixed teams. The team has rich experience, implements standardized processes, ensures code quality, improves development efficiency, and provides long-term technical support.'
        }
      ]
    };
  },
  methods: {
    setback(index) {
      return index % 2;
    },
    ResizeContainer() {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.model = screenWidth <= 700;
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      const metaKeywords = document.querySelector('meta[name="keywords"]');

      if (metaDescription) {
        metaDescription.setAttribute('content', this.texttotal.headertitle2);
      }
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.texttotal.headertitle1);
      }
    },
    setupShareData() {
      const url = window.location.href;
      const shareData = {
        url,
        pageTitle: this.texttotal.headertitle1,
        pageDescription: this.texttotal.headertitle2,
        pageKeywords: ''
      };
      shareUrl(shareData);
    },
    topTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    topTopmobile() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    clickConsult(item) {
      this.title = item;
      this.dialogVisible = true;
      sessionStorage.setItem('title', item);
    },
    hideDialog() {
      this.dialogVisible = false;
    }
  },
  mounted() {
    document.title = this.texttotal.headertitle1;
    this.setMetaTags();
    this.ResizeContainer();
  },
  created() {
    localStorage.setItem("home", 0);
    setTimeout(this.setupShareData, 1000);
  }
};
</script>

<template>
  <!-- Desktop Layout -->
  <div v-if="!model" ref="total" class="software-page">
    <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog" />
    <div class="header-container">
      <headtip :changeVisable="changeVisable" @showDialog="showPartner" />
    </div>

    <kefu @toptop="topTop" />
    <Anxunheader :title1="texttotal.headertitle1" :title2="texttotal.headertitle2"
      @clickConsult="clickConsult('Software development and talent outsourcing services')" />
<!-- 
    <div v-for="(item, index) in data" :key="index" class="content-section"
      :class="{ 'section-white': index % 2, 'section-blue': !(index % 2) }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="section-title" v-html="item.title" />
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="section-subtitle" v-html="item.title2" />
      <img :src="require('@/assets/software' + item.img)" class="section-image" />
    </div> -->
        <!-- 新增模块 -->
         <!--业务痛点与挑战模块 -->
         <div class="content-section" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Challenges and pain points</div>
      <div class="challenges-list">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <!--服务内容模块-->
    <div class="content-section" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Service content</div>
      <div class="service-list">
        <div v-for="(item, index) in serviceList" :key="index" class="service-card" v-sliden-in="{ duration: 800 }">
          <div class="service-title">{{ item.title }}</div>
          <div class="service-desc">{{ item.description }}</div>
          <div class="service-icon">
            <img :src="item.icon">
          </div>
        </div>
      </div>
    </div>
    <!-- 客户收益模块 -->
    <div class="content-section" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Customer income</div>
      <div class="benefit-list">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card">
          <div class="benefit-icon">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title">{{ item.title }}</div>
          <div class="benefit-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Layout -->
  <div v-else ref="totalModel" class="software-page-mobile">
    <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog" />
    <div class="mobile-header">
      <kefuMobile @topMobile="topTopmobile" />
      <headtip @showDialog="showPartner" />

      <div class="header-content">
        <div v-sliden-instep="{ duration: 800 }" class="logo-container">
          <img loading="lazy" src="@/assets/AnxunLogo.png" class="logo" />
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="header-title header-title-red">
          {{ texttotal.headertitle1Mobile }}
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="header-title header-title-dark">
          {{ texttotal.headertitle2 }}
        </div>
      </div>

      <div class="header-footer">
        <div v-sliden-instep="{ duration: 2400 }" class="slogan">
          Oil & Gas Digitalization, Simple and Practical
        </div>
        <div class="inquiry-button" @click="clickConsult('Software development and talent outsourcing services')">
          Product Inquiry
        </div>
      </div>
    </div>

    <!-- <div v-for="(item, index) in data2" :key="index" class="content-section"
      :class="{ 'section-white': index % 2, 'section-blue': !(index % 2) }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="section-title" v-html="item.title" />
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="section-subtitle" v-html="item.title2" />
      <img :src="require('@/assets/software' + item.img)" class="section-image" />
    </div> -->
    <!-- 新增模块 -->
         <!--业务痛点与挑战模块 -->
         <div class="content-section" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title"> Challenges and pain points</div>
      <div class="challenges-list-mobile">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <!--服务内容模块-->
    <div class="content-section" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Service content</div>
      <div class="service-list-mobile">
        <div v-for="(item, index) in serviceList" :key="index" class="service-card-mobile" v-sliden-in="{ duration: 800 }">
          <div class="service-title-mobile">{{ item.title }}</div>
          <div class="service-desc-mobile">{{ item.description }}</div>
          <div class="service-icon-mobile">
            <img :src="item.icon">
          </div>
        </div>
      </div>
    </div>
    <!-- 客户收益模块 -->
    <div class="content-section" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Customer income</div>
      <div class="benefit-list-mobile">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card-mobile">
          <div class="benefit-icon-mobile">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title-mobile">{{ item.title }}</div>
          <div class="benefit-desc-mobile">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div ref="bottom">
      <bottomTip />
    </div>
  </div>
</template>

<style scoped lang="scss">
// 通用样式
.section-white {
  background-color: white;
}

.section-blue {
  background-color: #ebf1fd;
}

.section-image {
  margin: auto;
}

// 桌面版样式
.software-page {
  .header-container {
    height: 6vh;
    background-color: rgb(245 244 246);
    position: fixed;
    z-index: 10;
    padding-left: 3vw;
    width: 100%;
  }

  .content-section {
    padding: 1.78739184177998vh 8.09763142692085vw;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;

    .section-title {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2.2060658579vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-subtitle {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-image {
      width: 90vw;
    }
        //业务痛点与挑战
        .challenges-list {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;

      .challenge-card {
        // flex: 1;
        margin: 0 15px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 20px;

          img {
            width: 70px;
            height: 70px;
          }
        }

        .challenge-title {
          font-size: 24px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 15px;
        }

        .challenge-desc {
          font-size: 16px;
          // color: #333;
          color: #000000;
          line-height: 1.6;
          text-align: left;
          max-width: 350px; // 添加最大宽度限制
          margin: 0 auto;
        }
      }
    }
        // 服务内容模块
        .service-list {
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
          gap: 20px;
          // flex-wrap: wrap;//允许换行
        }
    
        .service-card {
          background: white;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          padding: 20px;
          width: 460px;
          position: relative;
          min-height: 240px;
          display: flex;
          flex-direction: column;
          border: 1px solid #3a7afe;
        }
    
        .service-title {
          font-size: 25px;
          font-weight: 700;
          margin-bottom: 10px;
          color: #000000;
          // letter-spacing: 2px;
          text-align: center;
          position: relative;
          z-index: 2;
        }
    
        .service-desc {
          font-size: 16px;
          color: #000000;
          font-weight: 400;
          line-height: 1.5;
          min-height: 48px;
          max-width: 320px; // 限制最大宽度
          margin: 0 auto;
          // flex-grow: 1;
          position: relative;
          z-index: 2;
        }
    
        .service-icon {
          right: -35px;
          bottom: 0;
          opacity: 0.5;
          z-index: 1;
          position: absolute;
        }
    
        .service-icon img {
          width: 224px;
          height: 144px;
          object-fit: contain;
        }
                // 客户收益模块样式
        
    .benefit-list {
      display: flex;
      justify-content: space-between;
      gap: 40px;
      margin-top: 30px;
      flex-wrap: wrap;

      .benefit-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 6px 24px rgba(44, 100, 200, 0.18), 0 1.5px 6px rgba(44, 100, 200, 0.12);

        // padding: 40px 32px 92px 32px;
        padding: 0 0 32px 0;
        min-width: 260px;
        max-width: 360px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .benefit-icon {
          margin-bottom: 24px;

          img {
            // width: 100%;
            // // height: 200px;
            // object-fit: contain;
            width: 376px;
            height: 182px;
          }
        }

        .benefit-title {
          font-size: 24px;
          font-weight: bold;
          // color: #222;
          color: #000000;
          margin-bottom: 18px;
          text-align: center;
          line-height: 1.4;
        }

        .benefit-desc {
          font-size: 16px;
          // color: #333;
          color: #000000;
          // text-align: center;
          line-height: 1.8;
          min-height: 48px;
          max-width: 320px; // 限制最大宽度
          margin: 0 auto;
        }
      }
    }
  }
}

// 移动版样式
.software-page-mobile {
  .mobile-header {
    position: relative;
    width: 100%;
    height: 670px;
    padding: 2.84301606922126vh 2.86077411900635vw;
    background-image: url("../../../assets/bannerModel.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;

    .header-content {
      position: absolute;
      top: 65px;
      left: 9.17157712305026vw;
      z-index: 2;

      .logo-container {
        width: 120px;
        margin: 10px 0;
      }

      .logo {
        width: 100%;
      }

      .header-title {
        margin-top: 5px;
        width: 95%;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        line-height: 24px;

        &-red {
          font-weight: bolder;
          font-size: 20px;
          margin-top: 15px;
          line-height: 30px;
          color: #F44336;
        }

        &-dark {
          font-weight: bolder;
          margin-top: 15px;
          font-size: 14px;
          line-height: 28px;
          color: #2c3e50;
          text-align: left;
        }
      }
    }

    .header-footer {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);

      .slogan {
        width: 100vw;
        margin-bottom: 20px;
        font-weight: bolder;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        padding-bottom: 5px;
        color: #2f6dfd;
      }

      .inquiry-button {
        font-size: 14px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9.1px;
        width: fit-content;
        margin: auto;
        padding: 5px 4.6875vw;
        height: 35px;
        color: white;
        background-color: #2f6eff;
        border: 1px solid #2f6eff;
        overflow: hidden;
      }
    }
  }

  .content-section {
    padding: 1.78739184177998vh 2.09763142692085vw;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;

    .section-title {
      margin: 0 auto;
      text-align: center;
      height: 5vh;
      opacity: 1;
      font-weight: bold;
      font-size: 6vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-subtitle {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 5vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-image {
      width: 90vw;
    }
            //移动端挑战模块样式
            .challenges-list-mobile {
      margin-top: 20px;

      .challenge-card {
        margin-bottom: 30px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 15px;

          img {
            width: 50px;
            height: 50px;
          }
        }

        .challenge-title {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 10px;
        }

        .challenge-desc {
          font-size: 14px;
          color: #333;
          line-height: 1.5;
          text-align: left;
          max-width: 260px; // 移动端可以设置稍小的宽度
          margin: 0 auto;
        }
      }
    }
        // 服务内容移动端样式
        .service-list-mobile{
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 30px;
      .service-card-mobile{
        background: white;
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        padding: 20px;
        margin-bottom: 30px;
        width: 100%;
        border: 1px solid #3a7afe;
        display: flex;
        position: relative; /* 添加相对定位 */
        flex-direction: column;
        align-items: center;
      }
      .service-title-mobile{
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        z-index: 2;
      }
      .service-desc-mobile{
       font-size: 14px;
       color: #333;
       line-height: 1.5;
       max-width: 330px; // 移动端可以设置稍小的宽度
       margin: 0 auto;
       position: relative;
       z-index: 2;
       margin: 0 auto 15px; /* 增加底部间距 */
       flex-grow: 1; /* 让描述部分占据剩余空间 */
      }
      .service-icon-mobile{
      //  right: 0;
      // //  bottom: 0;
      right: 15px;
      bottom: 15px;
       opacity: 0.5;
       position: absolute;
       z-index: 1;
      }
      .service-icon-mobile img{
        width: 80px;
        height: 80px;
      }
    }
        // 客户收益移动端样式
        .benefit-list-mobile{
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 30px;

      .benefit-card-mobile{
        background: white;
        border-radius: 16px;
        box-shadow: 0 6px 24px rgba(44, 100, 200, 0.18), 0 1.5px 6px rgba(44, 100, 200, 0.12);
        padding: 0 0 20px 0;
        width: 100%;
        display: flex;
        // flex: 1;
      flex-direction: column;
      align-items: center;
      }
      .benefit-icon-mobile {
        margin-bottom: 16px;

        img {
          width: 100%;
          // height: 48px;
        }
      }
      .benefit-title-mobile {
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        margin-bottom: 10px;
        text-align: center;
        line-height: 1.4;
      }
      .benefit-desc-mobile {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        margin: 0 auto;
        max-width: 330px;
      }
     }
  }
}
</style>